import {Component, CUSTOM_ELEMENTS_SCHEMA, HostListener} from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {I18nModule} from '@spartacus/core';
import {LaunchDialogService} from '@spartacus/storefront';
import {SAP_EMPLOYEE_WARNING_SHOWN_KEY} from './sap-employee-popup.constants';

@UntilDestroy()
@Component({
  selector: 'dcp-sap-employee-popup',
  imports: [I18nModule],
  templateUrl: './sap-employee-popup.component.html',
  styleUrl: './sap-employee-popup.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SapEmployeePopupComponent {
  constructor(public launchDialogService: LaunchDialogService) {}

  @HostListener('document:keydown.escape')
  handleEsc(): void {
    this.confirm();
  }

  confirm(): void {
    sessionStorage.setItem(SAP_EMPLOYEE_WARNING_SHOWN_KEY, 'true');
    this.launchDialogService.closeDialog('Confirmed');
  }
}
